import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=a0c55fa0&scoped=true&lang=pug&"
import script from "./NameForm.vue?vue&type=script&lang=js&"
export * from "./NameForm.vue?vue&type=script&lang=js&"
import style0 from "./NameForm.vue?vue&type=style&index=0&id=a0c55fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c55fa0",
  null
  
)

export default component.exports